import { useLayoutEffect, useState, useEffect } from "react";
import Switch from "@mui/material/Switch";
import { FormControlLabel, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DayRipetizioniBoxNew from "./DayRipetizioniBoxNew";
import { setRipetizioneStatusNew, setRipetizioneDataFineNew } from "../../../redux/reducers/prenotazioneNew-reducer";
import GeneralCustomDateTimePicker from "../../UI/TimePicker/GeneralCustomDateTimePicker";
import { useTranslation } from "react-i18next";

const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1)).toString();

export default function RipetizioniBoxNew({ maxday, minDayValue, isConfiguredCorrectly }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [valueDataFineRipetizioni, setValueDataFineRipetizioni] = useState(tomorrow);
  const state = useSelector((state) => state.prenotazioneNew);
  const { ripetizioneStatus, ripetizioneDataFine, ripetizioneGiorni } = state;
  const minDayDate = new Date(minDayValue);

  useLayoutEffect(() => {
    if (!ripetizioneStatus) {
      setValueDataFineRipetizioni(tomorrow);
    }

    isConfiguredCorrectly(
      !ripetizioneStatus ||
        (ripetizioneStatus && ripetizioneGiorni.length > 0)
    );
  }, [ripetizioneStatus, ripetizioneGiorni]);

  const handleChangeData = (newValue) => {
    if (newValue !== null) {
      dispatch(setRipetizioneDataFineNew(newValue.toString()));
      setValueDataFineRipetizioni(newValue);
    } else {
      dispatch(setRipetizioneDataFineNew("null"));
      setValueDataFineRipetizioni("null");
    }
  };

  useEffect(() => {
    if (minDayDate) {
      let dateSaved = new Date(valueDataFineRipetizioni);
      let newDate = new Date(minDayDate);

      if (newDate.getTime() > dateSaved.getTime()) {
        setValueDataFineRipetizioni(minDayDate);
        dispatch(setRipetizioneDataFineNew(minDayDate.toString()));
      }
    }
  }, [minDayDate, ripetizioneStatus]);

  useLayoutEffect(() => {
    ripetizioneStatus
      ? setValueDataFineRipetizioni(ripetizioneDataFine)
      : setValueDataFineRipetizioni(tomorrow);
  }, [ripetizioneStatus]);

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <FormControlLabel
        control={
          <Switch
            onChange={() =>
              dispatch(setRipetizioneStatusNew(!ripetizioneStatus))
            }
            checked={ripetizioneStatus}
          />
        }
        label={t("Repeat_booking")}
      />
      {ripetizioneStatus && (
        <Box sx={{ display: "flex", width: "100%" }}>
          <DayRipetizioniBoxNew />
        </Box>
      )}
      {ripetizioneStatus && (
        <GeneralCustomDateTimePicker
          TypeTimePicker={5}
          label={t("Repeat_booking_until")}
          valueStart={valueDataFineRipetizioni}
          handleChange={handleChangeData}
          placeholder={t("Booking_date_placeholder")}
          minDate={minDayDate}
          maxDate={maxday}
          disabled={!ripetizioneStatus}
        />
      )}
    </Box>
  );
}